import type { Ref, TemplateRef } from "@vue/runtime-core";

export const useIdaFields = (initialValues: Record<string, unknown> | undefined, defaultValues: Record<string, unknown>, inputEvent: (data: Record<string, unknown>) => void) => {
  const formData = ref<Record<string, unknown>>({})

  const actualValues = computed(() => initialValues || defaultValues)

  watch(formData, () => {
    inputEvent(formData as unknown as Record<string, unknown>)
  }, { deep: true })

  const replacer = (_key: string, value: unknown) =>
    typeof value === 'undefined' ? null : value
  onMounted(() => {
    formData.value = JSON.parse(JSON.stringify(actualValues.value, replacer))
  })
  return { formData }
}

export const validateInput = (evt: KeyboardEvent) => {
  const target = (evt.target as HTMLInputElement).value.toString()
  const key = evt.key.toString()
  const [, decimalPlaces] = (target + key).split(/[.,]/)

  // only allow integers or decimals to two places
  if (!decimalPlaces || decimalPlaces.length <= 2) {
    return true
  } else {
    evt.preventDefault()
  }
}

export const useFieldHtmlAttribute = ({ field, attribute, value, element = 'input' }: { field: TemplateRef<{
     $el: Element
  }>, attribute: string, value: string, element: string }) => {
  onMounted(() => {
    const $input = field.value?.$el?.querySelector(element)
    if ($input) {
      $input.setAttribute(attribute, value)
    }
  })
}

/**
 * The human-readable field name vee-validate interpolates into messages:
 * the `fieldname.<name>` translation when one exists, otherwise the label.
 */
export const useFieldLabel = (
  name: MaybeRefOrGetter<string | undefined>,
  label: MaybeRefOrGetter<string | undefined>
) => {
  const i18n = useI18n()
  return computed(() => {
    const fieldName = toValue(name)
    if (fieldName) {
      const key = `fieldname.${fieldName}`
      if (i18n.has(key)) {
        return i18n.ts(key)
      }
    }
    return toValue(label)
  })
}

export const useRevalidateOnValueUpdateAfterBlur = <TValue>({
  value,
  errorMessage,
  validate
}: {
  value: Ref<TValue>
  errorMessage: Ref<string | undefined>
  validate: () => unknown
}) => {
  watch(value, () => {
    if (!errorMessage.value) {
      return
    }

    validate()
  })
}
